// removed by extract-text-webpack-plugin
module.exports = {"toastStyle":"toastStyle","Toastify__toast-container--top-right":"Toastify__toast-container--top-right"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/NotificationToast/style.scss
// module id = rdPs
// module chunks = 0